function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';

/* eslint-disable jsx-a11y/anchor-is-valid */
import { Row, Col, Button } from 'reactstrap';
import AddressMap from "../address/address-map";
import { _Icon as Icon } from "../../../core/common";
import { _translate } from "../../../../services/core";
var AddAddress = function AddAddress(_ref) {
  var goBack = _ref.goBack,
    onValidate = _ref.onValidate;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    address = _useState2[0],
    setAddress = _useState2[1];
  var handleMapChange = function handleMapChange(oldValue, newValue) {
    setAddress(newValue);
  };
  var handleValidate = function handleValidate() {
    onValidate(address);
  };
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    className: "mb-3 pb-1 border-bottom d-flex justify-content-start "
  }, /*#__PURE__*/React.createElement("a", {
    type: "button",
    onClick: function onClick() {
      return goBack();
    },
    className: "text-uppercase text-dark-pink"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "arrow-left"
  }), " ", _translate('back'))), /*#__PURE__*/React.createElement(Col, {
    sm: "12"
  }, /*#__PURE__*/React.createElement(AddressMap, {
    onChange: handleMapChange,
    index: 0
  })), /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    className: "mt-3 pt-2 border-top d-flex justify-content-start"
  }, /*#__PURE__*/React.createElement(Button, {
    color: "info",
    onClick: handleValidate,
    className: "collectorButton text-white"
  }, ' ', _translate('validate_address'), " ", /*#__PURE__*/React.createElement(Icon, {
    name: "check"
  }), ' ')));
};
export default AddAddress;